import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "bg-h-primary-50 border py-2" }
const _hoisted_3 = { class: "container mx-auto" }
const _hoisted_4 = { class: "container mx-auto px-5 md:px-3 mt-10" }
const _hoisted_5 = { class: "grid grid-cols-12 items-start gap-3" }
const _hoisted_6 = { class: "col-span-12 md:col-span-3 flex flex-col gap-5 mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "mt-[4px]"
}
const _hoisted_8 = { class: "rounded-lg border border-gray-200 overflow-hidden mt-[8px]" }
const _hoisted_9 = { class: "flex flex-col w-100" }
const _hoisted_10 = { class: "flex justify-between items-center w-full" }
const _hoisted_11 = { class: "hover:scale-95 transition-all" }
const _hoisted_12 = { class: "col-span-12 md:col-span-9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormInfo = _resolveComponent("FormInfo")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Materials = _resolveComponent("Materials")!
  const _component_LessonPlanComponent = _resolveComponent("LessonPlanComponent")!
  const _component_Quiz = _resolveComponent("Quiz")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BreadcrumbComponent, {
          home: _ctx.home,
          items: _ctx.items
        }, null, 8, ["home", "items"])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.add", { pt: "Objetivo", en: "Objective" })), 1),
          (_ctx.course.chapters)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Capítulo: ", en: "Chapter: " })), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.chapter.name), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (item, i) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  key: i,
                  class: _normalizeClass(`${
                  i == _ctx.active
                    ? 'btn-tab-active'
                    : item.done || !item.off
                    ? 'btn-tab-done'
                    : 'btn-tab-gray'
                }`),
                  disabled: item.off,
                  onClick: ($event: any) => (_ctx.changeTab(item.active))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.title), 1),
                      (item.done)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            name: "hi-solid-check-circle",
                            class: "text-green-500"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isEditPage && !item.done)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            name: "hi-solid-x-circle",
                            class: "text-h-error-400",
                            title: item.info
                          }, null, 8, ["title"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "disabled", "onClick"]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_TabView, {
            class: "custom-tabs-objective",
            activeIndex: _ctx.active,
            lazy: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FormInfo, {
                    onOnNext: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(1))),
                    onOnAllow: _ctx.allowSteps,
                    role: _ctx.user.role
                  }, null, 8, ["onOnAllow", "role"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Materials, {
                    onOnNext: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(2))),
                    onOnDeleted: _cache[2] || (_cache[2] = (e) => _ctx.isMaterialDeleted(e)),
                    onOnFilter: _ctx.onFilter,
                    onOnSearch: _ctx.onSearch,
                    onOnAllow: _ctx.allowSteps,
                    onOnScroll: _ctx.scrollMaterials,
                    role: _ctx.user.role,
                    loader: _ctx.loading
                  }, null, 8, ["onOnFilter", "onOnSearch", "onOnAllow", "onOnScroll", "role", "loader"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_LessonPlanComponent, {
                    onOnNext: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTab(3))),
                    lessonPlans: _ctx.lessonPlans,
                    objective: _ctx.objective,
                    loaderList: _ctx.loading,
                    role: _ctx.user.role
                  }, null, 8, ["lessonPlans", "objective", "loaderList", "role"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                default: _withCtx(() => [
                  (_ctx.objective.id)
                    ? (_openBlock(), _createBlock(_component_Quiz, {
                        key: 0,
                        onOnAllow: _ctx.allowSteps,
                        quizId: _ctx.quizId,
                        data: _ctx.quiz,
                        role: _ctx.user.role,
                        objective: _ctx.objective,
                        questions: _ctx.questions,
                        course: _ctx.course
                      }, null, 8, ["onOnAllow", "quizId", "data", "role", "objective", "questions", "course"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ])
      ])
    ])
  ]))
}